import React, { FC } from 'react';

import Loadable from 'react-loadable';

import { HiddenLoader } from 'src/components/react-loadable';

import { ForgeRepoPullRequestCardsProps } from './repo-pull-request-cards';

const LoadableRepoPullRequestCards = Loadable({
  loading: HiddenLoader,
  loader: () => import('./repo-pull-request-cards'),
});

/* eslint @typescript-eslint/ban-types: "warn" */
export const LazyForgeRepoPullRequestCards: FC<
  ForgeRepoPullRequestCardsProps
> = ({ currentUser, repository, pullRequest, workspace }) => {
  return (
    <LoadableRepoPullRequestCards
      currentUser={currentUser}
      repository={repository}
      pullRequest={pullRequest}
      workspace={workspace}
    />
  );
};
